var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPanelsWater(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 40.927,
    height: 38.426,
    viewBox: "0 0 40.927 38.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1461",
    "data-name": "Trac\\xE9 1461",
    d: "M64.251-43.589,47.212-74.827a.71.71,0,0,0-.623-.37H26.71a.737.737,0,0,0-.158.021h-.017a.687.687,0,0,0-.2.087.535.535,0,0,0-.051.038.743.743,0,0,0-.153.157c-.01.015-.023.027-.033.043a.616.616,0,0,0-.038.089.574.574,0,0,0-.025.057.709.709,0,0,0-.035.213v4.975a.712.712,0,0,0,.085.338l14.2,26.268a.71.71,0,0,0,.625.372H63.627a.71.71,0,0,0,.71-.71A.71.71,0,0,0,64.251-43.589Zm-6.079-8.179H53.4l-3.485-6.39h4.772ZM41.132-59.578H35.651l-3.485-6.39h5.482Zm-1.867-6.39h4.772l3.485,6.39H42.75Zm2.642,7.809,3.485,6.39H39.91l-3.485-6.39Zm1.618,0H48.3l3.485,6.39H47.01Zm10.387-1.42H49.14l-3.485-6.39h4.772Zm-7.745-14.2,3.485,6.39H44.88l-3.485-6.39Zm-6.39,0,3.485,6.39H38.491l-3.485-6.39Zm-6.39,0,3.485,6.39H31.391l-3.485-6.39Zm7.947,29.818L27.42-69.7V-71.7L42.552-43.959Zm2.836,0-3.485-6.39h5.482l3.485,6.39Zm7.1,0-3.485-6.39h4.772l3.485,6.39Zm6.39,0-3.485-6.39h4.772l3.485,6.39Z",
    transform: "translate(-26.003 75.197)",
    fill: "#e1f4fb"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1460",
    "data-name": "Trac\\xE9 1460",
    d: "M-937,95.243h803.932V-2067H-937Z",
    transform: "translate(937 2067)",
    fill: "#e1f4fb"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2928",
    "data-name": "Groupe 2928",
    transform: "translate(-159.836 -769.231)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2927",
    "data-name": "Groupe 2927",
    transform: "translate(159.836 775)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2926",
    "data-name": "Groupe 2926",
    transform: "translate(-537.632 -1111.997)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1459",
    "data-name": "Trac\\xE9 1459",
    d: "M25-76.2H64.454v33.774H25Z",
    transform: "translate(512.07 1187.635)",
    fill: "#e1f4fb"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "drop_1_",
    "data-name": "drop (1)",
    transform: "translate(189.551 769.231)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M5.593,15.537a5.617,5.617,0,0,1-3.947-1.625A5.551,5.551,0,0,1,0,9.965C0,7.818,2.6,4,4.158,1.713c.4-.579.7-1.025.971-1.456A.566.566,0,0,1,5.6,0a.521.521,0,0,1,.29.088.633.633,0,0,1,.169.169l.158.238L6.352.7c.2.3.426.645.676,1.013,1.656,2.431,4.158,6.105,4.158,8.232a5.621,5.621,0,0,1-5.593,5.593Zm0-14.014C5.5,1.652,5.4,1.8,5.3,1.955c-.075.113-.152.231-.234.349l-.012.017C3.478,4.652,1.1,8.175,1.1,9.944a4.472,4.472,0,0,0,1.308,3.187A4.551,4.551,0,0,0,5.593,14.44,4.471,4.471,0,0,0,8.78,13.131a4.548,4.548,0,0,0,1.309-3.187c0-1.719-2.209-5.016-3.822-7.422L6.121,2.3c-.083-.12-.164-.242-.233-.348L5.877,1.94C5.779,1.792,5.686,1.652,5.593,1.523ZM7.208,13.329a.575.575,0,0,1-.5-.3.516.516,0,0,1-.045-.409.57.57,0,0,1,.256-.33,2.569,2.569,0,0,0,.971-.929,2.716,2.716,0,0,0,.4-1.287.543.543,0,0,1,.533-.508h.037a.54.54,0,0,1,.506.57,3.575,3.575,0,0,1-.549,1.815,3.64,3.64,0,0,1-1.351,1.309A.523.523,0,0,1,7.208,13.329Z",
    transform: "translate(0.026 0)",
    fill: "#00a3da"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPanelsWater);
export default __webpack_public_path__ + "static/media/panels-water.05b944e48853d9259ad57f87c4ad79e7.svg";
export { ForwardRef as ReactComponent };